import { alertesFacturation } from './lib/suivi-affaires';
import { articlesAReapprovisionner } from './lib/valeur-stock';
import { EVENEMENT_VUE } from './lib/ecran';
import { Fragment, useEffect, useMemo, useRef, useState } from 'react';
import { Shell } from './components/layout/Shell.jsx';
import { SignalConsultation } from './components/SignalConsultation.jsx';
import { useAttestations } from './api/useAttestations';
import { useConsultations } from './api/useConsultations';
import { useSignaux } from './api/useSignaux';
import { attestationsARenouveler } from './lib/attestations';
import { Accueil } from './features/accueil/Accueil.jsx';
import { ConnexionScreen } from './features/auth/ConnexionScreen.jsx';
import { Onboarding, ficheApresInscription } from './features/auth/Onboarding.jsx';
import { ChoixSecuriteEcran } from './features/auth/ChoixSecuriteEcran.jsx';
import { hautFloute, poseLeFondDuHaut } from './lib/bord-haut';
import { Splash } from './features/auth/Splash.jsx';
import { ChantiersPage } from './features/chantiers/ChantiersPage.jsx';
import { ClientsPage } from './features/clients/ClientsPage.jsx';
import { CommandesPage } from './features/commandes/CommandesPage.jsx';
import { ComptaPage } from './features/compta/ComptaPage.jsx';
import { DepensesPage } from './features/compta/DepensesPage.jsx';
import { ImportPage } from './features/compta/ImportPage.jsx';
import { CourrierPage } from './features/courrier/CourrierPage.jsx';
import { BonsAchatPage } from './features/bons-achat/BonsAchatPage.jsx';
import { DevisPage } from './features/devis/DevisPage.jsx';
import { DechargePage } from './features/documents/DechargePage.jsx';
import { EquipePage } from './features/equipe/EquipePage.jsx';
import { FacturesPage } from './features/factures/FacturesPage.jsx';
import { GpsPage } from './features/gps/GpsPage.jsx';
import { LivraisonsPage } from './features/livraisons/LivraisonsPage.jsx';
import { ModelesPage } from './features/modeles/ModelesPage.jsx';
import { EspaceOuvrier } from './features/ouvrier/EspaceOuvrier.jsx';
import { SignauxPage } from './features/ouvrier/SignauxPage.jsx';
import EnvoyerEquipe from './features/equipe/EnvoyerEquipe.jsx';
import { PlanningPage } from './features/planning/PlanningPage.jsx';
import { AbonnementPage } from './features/plus/AbonnementPage.jsx';
import { AidePage } from './features/plus/AidePage.jsx';
import { ArchivesPage } from './features/plus/ArchivesPage.jsx';
import { EcranAVenir } from './features/plus/EcranAVenir.jsx';
import { FormationPage } from './features/plus/FormationPage.jsx';
import { EnvoisPage } from './features/plus/EnvoisPage.jsx';
import { InscriptionsPage } from './features/plus/InscriptionsPage.jsx';
import { JournalConnexionsPage } from './features/plus/JournalConnexionsPage.jsx';
import { NotificationsPage } from './features/plus/NotificationsPage.jsx';
import { OutilsPage } from './features/plus/OutilsPage.jsx';
import { PartagePage } from './features/plus/PartagePage.jsx';
import { PlusPage } from './features/plus/PlusPage.jsx';
import { PresentationPage } from './features/plus/PresentationPage.jsx';
import { SecuritePage } from './features/plus/SecuritePage.jsx';
import { StatsPage } from './features/plus/StatsPage.jsx';
import { SuggestionsPage } from './features/plus/SuggestionsPage.jsx';
import { SupportPage } from './features/plus/SupportPage.jsx';
import { VoileFinEssai, voileFinEssaiVisible } from './features/plus/VoileFinEssai.jsx';
import { RendezVousPage } from './features/rdv/RendezVousPage.jsx';
import { SoumissionsPage } from './features/soumissions/SoumissionsPage.jsx';
import { RecherchePage } from './features/recherche/RecherchePage.jsx';
import { ReglagesPage } from './features/reglages/ReglagesPage.jsx';
import { ArticlesBatimentPage } from './features/stock/ArticlesBatimentPage.jsx';
import { StockPage } from './features/stock/StockPage.jsx';
import {
  ecranOuvert,
  routeParDefaut,
  setAccessPerms,
  setAccessRoleGlobale,
  setNotifN,
  setPermAttestations,
  setPermStock,
  voitLesAttestations,
} from './lib/access';
import { setDeviseGlobale, setPaysMontants } from './lib/currency';
import { definitPaysDeLaSemaine } from './lib/semaine';
import { motOffre } from './lib/terminologie';
import { modulesSouscrits, routeAffichee, ROUTES_BATIMENT, ROUTES_MAGASIN } from './lib/modules';
import { appellePremierRappel, rappelAutoDemande } from './lib/rappels';
import { setLangGlobale } from './lib/i18n';
import { activeLaTraduction, langueDuTelephone } from './lib/traduction-ecran';
import { aujourdhuiIso, nextSeq, today } from './lib/utils';
import {
  CLE_CHANTIERS_ROUVERTS,
  chantiersFinisParLeurFacture,
  chantiersTerminesParLaFacture,
  termineLeChantier,
} from './lib/chantier-termine';
import { C } from './theme/palette';
import {
  authApi,
  catalogueApi,
  chantiersApi,
  chantiersDetailApi,
  clientsApi,
  commandesApi,
  congesApi,
  depensesApi,
  devisApi,
  employesApi,
  monEspaceApi,
  facturesApi,
  feuillesApi,
  livraisonsApi,
  rendezVousApi,
  societeApi,
  stockApi,
  ventesApi,
} from './api/resources';
import { ReglagesProvider } from './api/reglages.jsx';
import { DialogueProvider } from './components/Dialogue.jsx';
import { HistoriqueNavigation, usePileNavigation } from './lib/historique-navigation';
import { BandeauxPwa } from './pwa/BandeauxPwa.jsx';
import { LienFormules } from './components/LienFormules.jsx';
import { useSession } from './api/session.jsx';
import {
  noteSecuriteProposee,
  oublieSecuriteProposee,
  securiteDejaProposee,
} from './lib/securite-proposee';
import { rafraichitAuRetour } from './api/rafraichissement';
import { useSyncedCollection, useSyncedSingleton } from './api/useSyncedCollection';
import {
  articleVersDto,
  chantierDetailVersDto,
  clientVersDto,
  commandeVersDto,
  congeVersDto,
  depenseVersDto,
  devisVersDto,
  dtoVersArticle,
  dtoVersChantierDetail,
  dtoVersClient,
  dtoVersCommande,
  dtoVersConge,
  dtoVersDepense,
  dtoVersDevis,
  dtoVersEmploye,
  dtoVersMonEspace,
  dtoVersFacture,
  dtoVersFeuille,
  dtoVersLivraison,
  dtoVersPrestation,
  dtoVersRendezVous,
  dtoVersSociete,
  dtoVersVente,
  employeVersDto,
  monEspaceVersDto,
  factureVersDto,
  feuilleVersDto,
  livraisonVersDto,
  prestationVersDto,
  rendezVousVersDto,
  societeVersDto,
  venteVersDto,
} from './api/mappers';

/** Safari d'iPhone ou d'iPad, ou une icône ajoutée avant la barre d'état pleine. */
const IOS_NAVIGATEUR = hautFloute();

/**
 * Chargeurs des collections servies par l'API. Definis hors du composant pour
 * garder une identite stable entre deux rendus.
 */
// Les ecrans travaillent sur la collection entiere : la comptabilite additionne
// toutes les factures, la numerotation cherche le plus grand numero deja pose.
// Une premiere page de cinq cents suffisait tant que l'entreprise debutait ;
// passe ce cap, les documents suivants cessaient d'exister pour l'application —
// introuvables a l'ecran, absents du chiffre d'affaires, et leurs numeros
// reattribues a de nouvelles factures.
const chargeClients = () => clientsApi.toutes();
const chargeChantiers = () => chantiersDetailApi.liste();
const chargeDevis = () => devisApi.toutes();
const chargeFactures = () => facturesApi.toutes();
const chargeStock = () => stockApi.toutes();
const chargeEmployes = () => employesApi.liste(false);
// L'ouvrier n'a pas acces a la liste du personnel, qui porte le numero AVS,
// l'IBAN et le salaire de chacun : son espace lit sa seule fiche, que la
// collection recoit sous la forme d'une liste d'un element.
const chargeMonEspace = () => monEspaceApi.fiche().then((fiche) => [fiche]);
const refuseLEcriture = () =>
  Promise.reject(new Error("Cette fiche ne se cree ni ne se supprime depuis l'espace personnel."));
const ROLES_COMMERCE = ['patron', 'comptable', 'technicien', 'directeur', 'secretaire'];
const chargeConges = () => congesApi.liste();
const chargeDepenses = () => depensesApi.liste();
const chargeVentes = () => ventesApi.liste();
const chargeCommandes = () => commandesApi.liste();
const chargeLivraisons = () => livraisonsApi.liste();
const chargeRendezVous = () => rendezVousApi.liste();
const chargeConvocations = () => monEspaceApi.convocations();
const refuseLaConvocation = () =>
  Promise.reject(new Error("Un rendez-vous se fixe au bureau, non depuis l'espace personnel."));
const chargeCatalogue = () => catalogueApi.liste();
const chargeFeuilles = () => feuillesApi.liste();
const chargeSociete = () => societeApi.parametres();

/** L'offre que l'adresse demande d'ouvrir (« ?offre=12 »), ou rien. */
function offreDemandeeParLAdresse() {
  try {
    const id = Number(new URLSearchParams(window.location.search).get('offre'));
    return Number.isInteger(id) && id > 0 ? id : null;
  } catch (e) {
    return null;
  }
}

/** Retire « offre » de l'adresse : un rechargement ne rouvre pas l'offre. */
function retireLOffreDeLAdresse() {
  try {
    const url = new URL(window.location.href);
    url.searchParams.delete('offre');
    window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
  } catch (e) {}
}

/** Duree de la periode d'essai gratuite. */
const DUREE_ESSAI_MS = 30 * 86400000;

export function App() {
  const [splash, setSplash] = useState(true);
  // Sous l'heure de l'iPhone ou de l'iPad, le flou ne mêle plus de clair.
  useEffect(() => poseLeFondDuHaut(C.navy), []);
  // L'authentification est etablie par le serveur : tant qu'aucune session n'est
  // ouverte, aucune donnee n'est chargee — l'API les refuserait de toute facon.
  const { session, chargement: sessionEnCours, deconnexion } = useSession();
  const sessionOuverte = session !== null;
  const auth = session?.role ?? null;
  // Tout compte sans deuxième sécurité (application, e-mail ou SMS) se la voit
  // proposer à la connexion ; le compte neuf doit la choisir avant d'entrer. `undefined` tant que le serveur n'a pas répondu : l'écran
  // de l'application ne doit pas apparaître une seconde avant celui du choix.
  // Le compte du code PIN et l'espace client n'ont pas d'adresse à protéger.
  const [securiteAChoisir, setSecuriteAChoisir] = useState(undefined);
  const sansSecuriteAChoisir = !session || session.accesParPin || session.role === 'client';
  // Proposé une fois par connexion, pas à chaque bascule Bâtiment ↔ Magasin
  // du Mix (sauf au compte neuf, qui doit choisir).
  const personne = session?.email || session?.id;
  useEffect(() => {
    if (!session && !sessionEnCours) oublieSecuriteProposee();
  }, [session, sessionEnCours]);
  useEffect(() => {
    if (sansSecuriteAChoisir) {
      setSecuriteAChoisir(false);
      return undefined;
    }
    if (securiteDejaProposee(personne)) {
      setSecuriteAChoisir(false);
      return undefined;
    }
    let annule = false;
    setSecuriteAChoisir(undefined);
    Promise.resolve()
      .then(() => authApi.etatDoubleAuth())
      .then((etat) => {
        // Un objet quand le choix est à faire : le compte neuf ne peut pas le
        // remettre à plus tard, l'ancien le peut.
        if (annule) return;
        if (etat?.aChoisir && !etat.sansReport && personne != null) {
          noteSecuriteProposee(personne);
        }
        setSecuriteAChoisir(etat?.aChoisir ? { sansReport: Boolean(etat.sansReport) } : false);
      })
      // Le serveur ne répond pas : on entre, le choix reviendra à la connexion suivante.
      .catch(() => {
        if (!annule) setSecuriteAChoisir(false);
      });
    return () => {
      annule = true;
    };
  }, [session?.id, sansSecuriteAChoisir, personne]);
  useEffect(() => {
    setAccessRoleGlobale(session?.role ?? 'patron');
  }, [session?.role]);
  // Chaque ressource synchronisee rend compte ici de son enregistrement et de
  // son eventuel refus. La banniere ne regardait que les clients : un devis,
  // une fiche de paie ou un reglage refuse par le serveur etait recharge depuis
  // la base — la saisie disparaissait donc de l'ecran — sans que rien ne dise
  // pourquoi.
  const etatsSynchronises = [];
  const suivi = (etat) => {
    etatsSynchronises.push(etat);
    return etat;
  };
  const {
    valeur: soc,
    setValeur: setSoc,
    chargement: societeEnCours,
  } = suivi(
    useSyncedSingleton({
      actif: sessionOuverte,
      charge: chargeSociete,
      versInterface: dtoVersSociete,
      versApi: societeVersDto,
      enregistre: societeApi.enregistre,
    }),
  );
  useEffect(() => {
    if (soc?.devise) setDeviseGlobale(soc.devise);
  }, [soc?.devise]);
  // Les jours ouvrables suivent le week-end du pays de l'entreprise.
  useEffect(() => {
    definitPaysDeLaSemaine(soc?.pays || 'CH');
    setPaysMontants(soc?.pays || 'CH');
  }, [soc?.pays]);
  // Avant la connexion, il n'y a pas encore de société : l'écran d'entrée et
  // l'inscription parlent la langue du téléphone quand SwissTech la connaît.
  // Ils restaient en français pour une entreprise d'Allemagne ou d'Espagne.
  const langueEcran = sessionOuverte ? soc?.lang || 'fr' : langueDuTelephone();
  useEffect(() => {
    setLangGlobale(langueEcran);
    // Toute l'interface, côté patron comme côté ouvrier, dans la langue
    // choisie ; en français, rien n'est traduit.
    activeLaTraduction(langueEcran).catch(() => {});
  }, [langueEcran]);
  // L'univers choisi dans une entreprise mixte est un reglage d'appareil, au
  // meme titre que le mode d'affichage : le magasinier travaille au magasin,
  // le conducteur de travaux sur les chantiers, et chacun sur son telephone.
  // Sans cette trace, chaque rechargement les ramenait tous au batiment, et
  // le menu du magasin — commandes, bons de livraison — disparaissait.
  const [univers, setUnivers] = useState(() => {
    try {
      return localStorage.getItem('st_univers') || 'chantier';
    } catch (e) {
      return 'chantier';
    }
  });
  const [nav, setNav] = useState('accueil');
  // Rappuyer sur l'entree de menu deja ouverte doit ramener a sa liste : la
  // page gardait sa fiche a l'ecran — une facture ouverte restait affichee
  // quand on appuyait sur « Factures ». Le compteur remonte la page, et elle
  // repart de son premier ecran.
  const [passage, setPassage] = useState(0);
  // Chaque écran quitté s'empile : la flèche « ← » de l'en-tête y ramène,
  // sur tous les écrans, comme dans la maquette.
  const historique = usePileNavigation(nav, setNav);
  const oublierHistorique = historique.oublier;
  // Une notification peut mener plus loin que l'écran : le message d'un
  // employé ouvre sa conversation, pas la liste de l'équipe.
  const [aOuvrir, setAOuvrir] = useState(null);
  const allerA = (cible, ouverture) => {
    setAOuvrir(ouverture ?? null);
    // En Mix, un écran de l'autre univers y fait passer : la cloche du
    // bâtiment ouvre une commande du magasin sans retomber sur l'accueil.
    if (soc?.secteur === 'mixte') {
      const versLeMagasin = univers !== 'magasin' && ROUTES_MAGASIN.includes(cible);
      const versLeBatiment = univers === 'magasin' && ROUTES_BATIMENT.includes(cible);
      if (versLeMagasin || versLeBatiment) {
        const u = versLeMagasin ? 'magasin' : 'chantier';
        setUnivers(u);
        try {
          localStorage.setItem('st_univers', u);
        } catch (e) {}
      }
    }
    if (cible === nav) setPassage((p) => p + 1);
    historique.aller(cible);
    // Revenir sur un écran, c'est vouloir le voir à jour : ce que l'équipe a
    // saisi entre-temps se relit, sans attendre le tour de la minute.
    rafraichitAuRetour();
  };
  // Mode d'affichage (telephone, tablette, ordinateur) : propre a l'appareil et
  // non a l'entreprise, il reste donc le seul reglage conserve localement.
  const [vue, setVue] = useState(() => {
    try {
      return localStorage.getItem('st_vue') || 'auto';
    } catch (e) {
      return 'auto';
    }
  });
  const [winW, setWinW] = useState(typeof window !== 'undefined' ? window.innerWidth : 480);
  useEffect(() => {
    if (typeof window === 'undefined') return;
    const h = () => setWinW(window.innerWidth);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  // De retour d'une autre application (WhatsApp, Mail, le partage), l'iPhone
  // laissait la page défilée de quelques points : l'en-tête passait sous
  // l'heure et la batterie, et une bande vide restait en bas. La page revient
  // en place chaque fois que l'application reparaît.
  useEffect(() => {
    if (typeof window === 'undefined') return undefined;
    const remet = () => {
      if (document.visibilityState === 'hidden') return;
      if (window.scrollX || window.scrollY) window.scrollTo(0, 0);
    };
    const evenements = ['pageshow', 'focus', 'orientationchange', 'resize'];
    evenements.forEach((e) => window.addEventListener(e, remet));
    document.addEventListener('visibilitychange', remet);
    return () => {
      evenements.forEach((e) => window.removeEventListener(e, remet));
      document.removeEventListener('visibilitychange', remet);
    };
  }, []);
  useEffect(() => {
    try {
      localStorage.setItem('st_vue', vue);
    } catch (e) {}
    // Le cadre des écrans se réadapte tout de suite au nouveau réglage.
    window.dispatchEvent(new Event(EVENEMENT_VUE));
  }, [vue]);
  // Toutes les collections metier sont persistees en base : le hook charge
  // l'existant, observe les modifications de l'ecran et les reecrit.
  //
  // Une collection fermee au role courant n'est pas demandee du tout : la
  // charger reviendrait a essuyer un refus a chaque ouverture de session, et
  // l'ecran afficherait une erreur de reseau pour une simple regle d'acces.
  const role = session?.role ?? null;
  const litLeCommerce = ROLES_COMMERCE.includes(role);
  const estOuvrier = role === 'ouvrier';
  // Une page fermee au role dans Reglages → Acces n'est pas demandee non
  // plus : le serveur la refuserait. On attend la societe pour le savoir.
  const ouvert = (cle) => soc != null && ecranOuvert(cle, soc, role);
  // Le client qui ouvre son offre ou sa facture : la cloche le compte, et un
  // signal descend en haut de l'écran.
  const consultations = useConsultations(sessionOuverte && litLeCommerce);
  // La cloche de l'employé — et du patron, de la secrétaire ou du technicien
  // rattachés à une fiche : messages, rendez-vous, plans, documents du bureau.
  const signaux = useSignaux(sessionOuverte && session?.employeId != null);
  // Les attestations de l'entreprise : 30 jours avant leur fin, la cloche
  // prévient de les renouveler. Seuls ceux qui y ont droit les lisent : le
  // serveur refuse les autres (Réglages → Accès).
  const attestations = useAttestations(
    sessionOuverte && !estOuvrier && voitLesAttestations(soc?.permAttestations, role),
    soc?.id,
  );
  // Les collections d'un module que la societe n'a pas souscrit ne sont pas
  // demandees non plus : le serveur les refuse (403 « module-non-souscrit »),
  // et l'ecran afficherait une erreur pour une regle d'abonnement. Une
  // societe Mix charge les deux, quel que soit l'univers affiche : la
  // comptabilite additionne chantiers et ventes.
  const modules = modulesSouscrits(soc?.secteur);
  const { donnees: clients, setDonnees: setClients } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && litLeCommerce && ouvert('clients'),
      charge: chargeClients,
      versInterface: dtoVersClient,
      versApi: clientVersDto,
      cree: clientsApi.cree,
      metAJour: clientsApi.metAJour,
      supprime: clientsApi.supprime,
    }),
  );
  const {
    donnees: chantiers,
    setDonnees: setChantiers,
    recharge: rechargeChantiers,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && modules.batiment && ouvert('chantiers'),
      charge: chargeChantiers,
      versInterface: dtoVersChantierDetail,
      versApi: chantierDetailVersDto,
      cree: chantiersDetailApi.cree,
      metAJour: chantiersDetailApi.metAJour,
      // Sans suppression, « Supprimer ce chantier » ne retirait le chantier
      // que de l'ecran : il revenait au rechargement. Les devis, factures,
      // depenses et feuilles qui le designent gardent leur ligne, le lien
      // retombe a nul (cles etrangeres SET NULL).
      supprime: chantiersApi.supprime,
    }),
  );
  const {
    donnees: devis,
    setDonnees: setDevis,
    recharge: rechargeDevis,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && litLeCommerce && ouvert('offres'),
      charge: chargeDevis,
      versInterface: dtoVersDevis,
      versApi: devisVersDto,
      cree: devisApi.cree,
      metAJour: devisApi.metAJour,
      supprime: devisApi.supprime,
    }),
  );
  // Le lien du courriel « Réponse du client » (…/?offre=12) ouvre cette
  // offre, et non l'accueil : le patron y voit la signature, le jour et
  // l'heure. L'adresse le garde le temps de la connexion, puis le perd.
  const offreDeLAdresse = useRef(offreDemandeeParLAdresse());
  useEffect(() => {
    const id = offreDeLAdresse.current;
    if (!id || !sessionOuverte || !soc?.secteur) return;
    if (!(devis || []).some((d) => d.id === id)) return;
    offreDeLAdresse.current = null;
    retireLOffreDeLAdresse();
    allerA('devis', { devisId: id });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionOuverte, soc?.secteur, devis]);
  const {
    donnees: stock,
    setDonnees: setStock,
    recharge: rechargeStock,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte,
      charge: chargeStock,
      versInterface: dtoVersArticle,
      versApi: articleVersDto,
      cree: stockApi.cree,
      metAJour: stockApi.metAJour,
      supprime: stockApi.supprime,
    }),
  );
  const { donnees: ventes, setDonnees: setVentes } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && modules.magasin && litLeCommerce,
      charge: chargeVentes,
      versInterface: dtoVersVente,
      versApi: venteVersDto,
      cree: ventesApi.cree,
      metAJour: () => Promise.resolve(),
      supprime: ventesApi.supprime,
    }),
  );
  const { donnees: conges, setDonnees: setConges } = suivi(
    useSyncedCollection({
      actif: sessionOuverte,
      charge: chargeConges,
      versInterface: dtoVersConge,
      versApi: congeVersDto,
      cree: congesApi.cree,
      metAJour: congesApi.metAJour,
      supprime: congesApi.supprime,
    }),
  );
  // La collection des factures n'est tenue que pour un rôle dont l'écran
  // Factures est ouvert : un livreur qui signe un bon sans cet écran crée sa
  // facture par l'API directement (LivraisonsPage), et ne la relit pas ici.
  const facturesActives = sessionOuverte && litLeCommerce && ouvert('factures');
  // Au magasin, le serveur sort du stock la marchandise de chaque facture (et
  // la rend quand on la retire) : le stock affiché se relit après chaque
  // facture enregistrée, sans quoi l'écran renverrait l'ancienne quantité.
  const rechargeStockApres = useRef(rechargeStock);
  rechargeStockApres.current = rechargeStock;
  const puisRelitLeStock = (promesse) =>
    promesse.then((r) => {
      if (rechargeStockApres.current) rechargeStockApres.current();
      return r;
    });
  const {
    donnees: factures,
    setDonnees: setFactures,
    recharge: rechargeFactures,
  } = suivi(
    useSyncedCollection({
      actif: facturesActives,
      charge: chargeFactures,
      versInterface: dtoVersFacture,
      versApi: factureVersDto,
      cree: (dto) => puisRelitLeStock(facturesApi.cree(dto)),
      metAJour: (id, dto) => puisRelitLeStock(facturesApi.metAJour(id, dto)),
      supprime: (id) => puisRelitLeStock(facturesApi.supprime(id)),
    }),
  );
  // La facture finale d'une offre envoyée ou payée termine son chantier : il
  // restait « En cours » pour toujours, seul le PV de réception le terminait.
  // L'état compte, pas seulement le passage à l'envoi vu dans cet écran : une
  // facture partie avant cette règle, ou depuis un autre appareil, termine
  // aussi son chantier. Un chantier rouvert à la main reste ouvert jusqu'à
  // l'envoi d'une nouvelle facture finale.
  const statutsFactures = useRef(null);
  const rouvertsBrut = soc?.parametres?.[CLE_CHANTIERS_ROUVERTS];
  useEffect(() => {
    if (!factures?.length || !chantiers?.length) return;
    let rouverts = [];
    try {
      rouverts = rouvertsBrut ? JSON.parse(rouvertsBrut) : [];
    } catch {
      rouverts = [];
    }
    const vientDePartir =
      statutsFactures.current === null
        ? []
        : chantiersTerminesParLaFacture(statutsFactures.current, factures, chantiers);
    statutsFactures.current = new Map(factures.map((f) => [f.id, f.statut]));
    const aTerminer = [
      ...new Set([
        ...vientDePartir,
        ...chantiersFinisParLeurFacture(factures, chantiers, rouverts),
      ]),
    ];
    if (!aTerminer.length) return;
    setChantiers((p) =>
      p.map((c) => (aTerminer.includes(c.id) ? termineLeChantier(c, aujourdhuiIso()) : c)),
    );
    // Rouvert puis refermé par une nouvelle facture : il n'est plus « rouvert ».
    const encore = rouverts.filter((id) => !vientDePartir.map(String).includes(String(id)));
    if (encore.length !== rouverts.length) {
      setSoc((p) =>
        p
          ? {
              ...p,
              parametres: {
                ...(p.parametres ?? {}),
                [CLE_CHANTIERS_ROUVERTS]: JSON.stringify(encore),
              },
            }
          : p,
      );
    }
  }, [factures, chantiers, setChantiers, rouvertsBrut, setSoc]);
  // La fiche de l'employe se lit a deux adresses selon le role : la direction
  // voit toute l'equipe, l'ouvrier sa seule fiche, allegee de la paie.
  const accesEmployes = useMemo(
    () =>
      estOuvrier
        ? {
            charge: chargeMonEspace,
            versInterface: dtoVersMonEspace,
            versApi: monEspaceVersDto,
            cree: refuseLEcriture,
            metAJour: (id, fiche) => monEspaceApi.enregistre(fiche),
            supprime: undefined,
          }
        : {
            charge: chargeEmployes,
            versInterface: dtoVersEmploye,
            versApi: employeVersDto,
            cree: employesApi.cree,
            metAJour: employesApi.metAJour,
            supprime: employesApi.desactive,
          },
    [estOuvrier],
  );
  const {
    donnees: employes,
    setDonnees: setEmployes,
    recharge: rechargeEmployes,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && ouvert('equipe'),
      ...accesEmployes,
    }),
  );
  const { donnees: frais, setDonnees: setFrais } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && litLeCommerce && ouvert('depenses'),
      charge: chargeDepenses,
      versInterface: dtoVersDepense,
      versApi: depenseVersDto,
      cree: depensesApi.cree,
      metAJour: depensesApi.metAJour,
      supprime: depensesApi.supprime,
    }),
  );
  const {
    donnees: livraisons,
    setDonnees: setLivraisons,
    enregistrement: livraisonsEnregistrement,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && modules.magasin && litLeCommerce,
      charge: chargeLivraisons,
      versInterface: dtoVersLivraison,
      versApi: livraisonVersDto,
      cree: livraisonsApi.cree,
      metAJour: livraisonsApi.metAJour,
      supprime: livraisonsApi.supprime,
    }),
  );
  const {
    donnees: commandes,
    setDonnees: setCommandes,
    recharge: rechargeCommandes,
  } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && modules.magasin && litLeCommerce,
      charge: chargeCommandes,
      versInterface: dtoVersCommande,
      versApi: commandeVersDto,
      cree: commandesApi.cree,
      metAJour: commandesApi.metAJour,
      supprime: commandesApi.supprime,
    }),
  );
  // Le serveur passe la commande a « Livree » quand son bon est livre ou
  // signe. L'ecran, qui la gardait « Prete », relit les commandes une fois le
  // bon enregistre : il ne les reecrit pas lui-meme, ce qui renvoyait au
  // serveur toutes celles qu'il croyait en retard.
  const bonsDejaSuivis = useRef(new Set());
  useEffect(() => {
    if (livraisonsEnregistrement) return;
    const nouveaux = (livraisons || []).filter(
      (b) =>
        b.commandeId != null &&
        ['Signé', 'Livrée'].includes(b.statut) &&
        !bonsDejaSuivis.current.has(`${b.id}:${b.statut}`),
    );
    if (!nouveaux.length) return;
    nouveaux.forEach((b) => bonsDejaSuivis.current.add(`${b.id}:${b.statut}`));
    const enRetard = (commandes || []).some(
      (c) =>
        nouveaux.some((b) => String(b.commandeId) === String(c.id)) &&
        c.statut !== 'Livrée' &&
        c.statut !== 'Annulée',
    );
    if (enRetard) rechargeCommandes?.();
  }, [livraisons, livraisonsEnregistrement, commandes, rechargeCommandes]);
  // Les rendez-vous se lisent a deux adresses selon le role, comme les fiches
  // d'employe : le bureau les voit tous, l'ouvrier ses seules convocations. Il
  // n'en chargeait aucun, et son onglet annoncait « Aucun rendez-vous ».
  const accesRendezVous = useMemo(
    () =>
      estOuvrier
        ? {
            charge: chargeConvocations,
            versInterface: dtoVersRendezVous,
            versApi: rendezVousVersDto,
            cree: refuseLaConvocation,
            metAJour: refuseLaConvocation,
            supprime: undefined,
          }
        : {
            charge: chargeRendezVous,
            versInterface: dtoVersRendezVous,
            versApi: rendezVousVersDto,
            cree: rendezVousApi.cree,
            metAJour: rendezVousApi.metAJour,
            supprime: rendezVousApi.supprime,
          },
    [estOuvrier],
  );
  const { donnees: rdv, setDonnees: setRdv } = suivi(
    useSyncedCollection({
      actif: sessionOuverte && (estOuvrier || (litLeCommerce && ouvert('rdv'))),
      ...accesRendezVous,
    }),
  );
  const { donnees: catalogue, setDonnees: setCatalogue } = suivi(
    useSyncedCollection({
      actif: sessionOuverte,
      charge: chargeCatalogue,
      versInterface: dtoVersPrestation,
      versApi: prestationVersDto,
      cree: catalogueApi.cree,
      metAJour: catalogueApi.metAJour,
      supprime: catalogueApi.supprime,
    }),
  );
  const { donnees: feuilles, setDonnees: setFeuilles } = suivi(
    useSyncedCollection({
      actif: sessionOuverte,
      charge: chargeFeuilles,
      versInterface: dtoVersFeuille,
      versApi: feuilleVersDto,
      cree: feuillesApi.cree,
      metAJour: feuillesApi.metAJour,
      supprime: feuillesApi.supprime,
    }),
  );
  // Le premier refus rencontre suffit a alerter : en enchainer plusieurs dans
  // la banniere ne dirait rien de plus a qui doit surtout savoir que sa saisie
  // n'est pas passee.
  const erreurReseau = etatsSynchronises.find((e) => e.erreur)?.erreur ?? null;
  const enregistrement = etatsSynchronises.some((e) => e.enregistrement);
  // Tant qu'une collection arrive encore, l'accueil le dit au lieu d'afficher
  // « CHF 0.00 » comme un vrai chiffre.
  const donneesEnChargement = etatsSynchronises.some((e) => e.chargement);

  const [, setTick] = useState(0);
  const forceRefresh = () => setTick((t) => t + 1);

  // Les traitements differes n'ont de sens qu'une fois les donnees revenues
  // de l'API ; sans cette garde ils s'appliqueraient a des collections vides.
  const loaded = soc !== null;

  // Une ouverture de session, non le rechargement d'une page dont la session
  // courait déjà : l'historique repart de zéro. Le journal des connexions est
  // tenu par le serveur, à chaque ouverture de session.
  const sessionPrecedente = useRef(undefined);
  useEffect(() => {
    if (sessionEnCours) return;
    const precedente = sessionPrecedente.current;
    sessionPrecedente.current = session;
    if (precedente === undefined || precedente !== null || session === null) return;

    // Une nouvelle session repart sans historique : la flèche ne doit pas
    // rouvrir les écrans du compte précédent.
    oublierHistorique();
    setNav(session.role === 'ouvrier' ? 'ouvrier' : 'accueil');
  }, [session, sessionEnCours, oublierHistorique]);

  // Le rappel automatique se demande, il ne se subit pas.
  //
  // L'application etablissait le premier rappel de toute facture en retard des
  // qu'on l'ouvrait. Rien n'etait pourtant envoye -- elle ne sait pas expedier
  // seule -- mais la facture portait desormais un rappel date du jour. Le
  // dossier disait le contraire de ce que le client avait recu, et le second
  // rappel partait comme s'il y en avait eu un premier.
  useEffect(() => {
    if (!loaded) return;
    if (!rappelAutoDemande(soc)) return;
    setFactures((prev) => {
      let chg = false;
      const arr = (prev || []).map((f) => {
        if (appellePremierRappel(f)) {
          chg = true;
          return {
            ...f,
            rappelNiveau: 1,
            rappelLe: today(),
            rappelFrais: f.rappelFrais || 0,
            rappelAutoLe: today(),
          };
        }
        return f;
      });
      return chg ? arr : prev;
    });
  }, [loaded, soc && soc.rappelAuto]);

  useEffect(() => {
    const t = setTimeout(() => setSplash(false), 1500);
    return () => clearTimeout(t);
  }, []);
  const [trialLeft, setTrialLeft] = useState(30);
  const [abonne, setAbonne] = useState(false);
  const [trialHide, setTrialHide] = useState(false);
  // L'erreur que l'utilisateur a fermee : la banniere ne revient que pour une
  // erreur nouvelle.
  const [erreurFermee, setErreurFermee] = useState(null);
  // L'abonnement et la periode d'essai sont portes par la societe : ils doivent
  // survivre a un changement d'appareil et valoir pour toute l'entreprise.
  // C'est le serveur qui dit ou en est l'essai et si une formule est active ;
  // le calcul local ne sert qu'aux fiches d'avant, qui n'ont pas cet etat.
  useEffect(() => {
    if (!soc) return;
    const abo = soc.abonnement;
    if (abo) {
      setAbonne(abo.etat === 'ACTIF' || abo.etat === 'SUSPENDU');
      setTrialLeft(abo.joursEssaiRestants ?? 0);
      return;
    }
    setAbonne(soc.abonne === true);
    const debut = soc.essaiDebut ? new Date(soc.essaiDebut).getTime() : Date.now();
    setTrialLeft(Math.ceil((DUREE_ESSAI_MS - (Date.now() - debut)) / 86400000));
  }, [soc]);
  // « J'ai souscrit » sur le voile de fin d'essai : la page Abonnement
  // demande alors de confirmer la formule souscrite. Rien ne se debloque
  // avant que le serveur l'ait enregistree.
  const [souscriptionAConfirmer, setSouscriptionAConfirmer] = useState(false);
  // La formule choisie sur la page Abonnement revient ici, sans reecrire la
  // fiche : la route de l'abonnement l'a deja enregistree.
  const surAbonnement = (abonnement) => {
    setSouscriptionAConfirmer(false);
    setSoc((p) => (p ? { ...p, abonnement, abonne: abonnement?.etat === 'ACTIF' } : p));
  };
  // Le module change par l'abonnement : la route l'a enregistre avec le
  // nouveau tarif, et la fiche qu'elle rend dit l'un et l'autre.
  const surModule = (fiche) => {
    const relue = dtoVersSociete(fiche);
    setSoc((p) => (p ? { ...p, secteur: relue.secteur, abonnement: relue.abonnement } : p));
    if (relue.secteur === 'mixte') setUnivers(univers === 'magasin' ? 'magasin' : 'chantier');
  };
  const changerUnivers = (u) => {
    setUnivers(u);
    // Les écrans de l'autre univers n'ont plus de sens après la bascule
    // (commandes du magasin, planning des chantiers) : la pile repart à zéro.
    historique.oublier();
    setNav('accueil');
    try {
      localStorage.setItem('st_univers', u);
    } catch (e) {}
  };

  let content;
  try {
    setNotifN(
      // L'employé ne compte que sa cloche : la somme du bureau compterait ses
      // propres messages encore non lus par la direction.
      estOuvrier
        ? signaux.nonVus
        : signaux.nonVus +
            (employes || []).reduce(
              (a, e) => a + (e.messages || []).filter((m) => m.de === 'employe' && !m.lu).length,
              0,
            ) +
            (conges || []).filter((c) => c.statut === 'En attente').length +
            // Une commande passée par un client — depuis son espace ou son lien —
            // attend que le magasin l'accepte : la cloche la signale.
            (commandes || []).filter((c) => c.statut === 'Reçue').length +
            consultations.nonLues +
            // Un chantier fini sans facture finale, une facture de chantier en
            // retard : la cloche le rappelle au patron.
            alertesFacturation({ devis, factures, chantiers }).length +
            // Un article tombé au seuil choisi par le patron (le « Min. » de sa
            // fiche) : la cloche le signale, au magasin comme au dépôt.
            articlesAReapprovisionner(stock).length +
            attestationsARenouveler(attestations.pieces).length,
    );
  } catch (e) {}
  try {
    setPermStock(soc && soc.permStock);
  } catch (e) {}
  try {
    setPermAttestations(soc && soc.permAttestations);
  } catch (e) {}
  try {
    setAccessPerms(soc && soc.acces);
  } catch (e) {}
  // Trois portes successives : la session, puis les parametres de l'entreprise,
  // puis l'application. Aucune donnee n'est demandee avant la premiere.
  if (splash || sessionEnCours || (sessionOuverte && societeEnCours)) content = <Splash />;
  else if (!sessionOuverte) content = <ConnexionScreen />;
  else if (!soc || !soc.secteur)
    content = (
      <Onboarding
        societe={soc}
        onDone={(s, fiche) => {
          const _base = ((s && s.nom) || soc?.nom || 'SOC')
            .replace(/[^A-Za-zÀ-ÿ]/g, '')
            .toUpperCase()
            .slice(0, 4)
            .padEnd(4, 'X');
          const _codeSoc = _base + '-' + Math.floor(10000 + Math.random() * 90000);
          const s2 = { ...s, codeSociete: _codeSoc };
          // L'entreprise existe deja : elle est nee avec le compte. L'assistant
          // la complete, il ne la remplace pas — sans quoi l'identifiant et la
          // periode d'essai seraient perdus. Le module, la formule et le Pack
          // IA viennent de la fiche que le serveur vient d'enregistrer.
          setSoc((precedent) => ficheApresInscription(precedent, s2, fiche));
          if (s2.devise) setDeviseGlobale(s2.devise);
          setNav('accueil');
          setUnivers('chantier');
        }}
      />
    );
  else if (securiteAChoisir === undefined) content = <Splash />;
  else if (securiteAChoisir)
    content = (
      <ChoixSecuriteEcran
        sansReport={securiteAChoisir.sansReport}
        onTermine={() => setSecuriteAChoisir(false)}
      />
    );
  else {
    const estMixte = soc.secteur === 'mixte';
    const _ov = estMixte ? (soc.profils || {})[univers] || {} : {};
    const socEff = estMixte
      ? {
          ...soc,
          ...Object.fromEntries(
            Object.entries(_ov).filter(([k, v]) => v !== undefined && v !== ''),
          ),
          secteur: univers === 'magasin' ? 'magasin' : 'batiment',
        }
      : soc;
    const shared = {
      onNav: allerA,
      soc: socEff,
      estMixte,
      univers,
      setUnivers: changerUnivers,
      onAbonnement: surAbonnement,
    };
    const repli = routeParDefaut();
    // Une route n'est ouverte que si le role y a droit et qu'elle appartient
    // au module affiche — en Mix, a l'univers de la bascule. Un ecran de
    // l'autre module (les chantiers en magasin, la caisse au batiment)
    // renvoie a la route par defaut, comme une route fermee au role.
    const magAffiche = estMixte ? univers === 'magasin' : soc.secteur === 'magasin';
    const route = routeAffichee(nav, magAffiche, repli);
    if (route !== nav) {
      setTimeout(() => setNav(repli), 0);
    }
    const titre =
      route === 'accueil'
        ? null
        : route === 'plus'
          ? 'Plus'
          : route.charAt(0).toUpperCase() + route.slice(1);
    let page;
    switch (route) {
      case 'accueil':
        page = (
          <Accueil
            {...shared}
            prenom={
              String(session?.nom || '')
                .trim()
                .split(' ')[0]
            }
            essai={
              soc && soc.secteur && auth && !abonne && !estOuvrier && !trialHide && trialLeft > 0
                ? { jours: trialLeft, masque: () => setTrialHide(true) }
                : null
            }
            clients={clients}
            setClients={setClients}
            chantiers={chantiers}
            setChantiers={setChantiers}
            devis={devis}
            stock={stock}
            ventes={ventes}
            conges={conges}
            factures={factures}
            employes={employes}
            frais={frais}
            enChargement={donneesEnChargement}
          />
        );
        break;
      case 'devis':
        page = (
          <DevisPage
            {...shared}
            ouvrir={aOuvrir}
            onOuvert={() => setAOuvrir(null)}
            devis={devis}
            setDevis={setDevis}
            rechargeDevis={rechargeDevis}
            rechargeChantiers={rechargeChantiers}
            rechargeFactures={rechargeFactures}
            clients={clients}
            setClients={setClients}
            chantiers={chantiers}
            setChantiers={setChantiers}
            factures={factures}
            setFactures={setFactures}
            stock={stock}
            catalogue={catalogue}
            setCatalogue={setCatalogue}
            setSoc={setSoc}
          />
        );
        break;
      case 'bonc':
        page = (
          <DevisPage
            {...shared}
            devis={devis}
            setDevis={setDevis}
            rechargeDevis={rechargeDevis}
            rechargeChantiers={rechargeChantiers}
            rechargeFactures={rechargeFactures}
            clients={clients}
            setClients={setClients}
            chantiers={chantiers}
            setChantiers={setChantiers}
            factures={factures}
            setFactures={setFactures}
            stock={stock}
            catalogue={catalogue}
            setCatalogue={setCatalogue}
            setSoc={setSoc}
            initBC
          />
        );
        break;
      case 'factures':
        page = (
          <FacturesPage
            {...shared}
            ouvrir={aOuvrir}
            onOuvert={() => setAOuvrir(null)}
            setSoc={setSoc}
            factures={factures}
            setFactures={setFactures}
            devis={devis}
            chantiers={chantiers}
            clients={clients}
            setClients={setClients}
            stock={stock}
            setStock={setStock}
            catalogue={catalogue}
            setCatalogue={setCatalogue}
            rechargeFactures={rechargeFactures}
          />
        );
        break;
      case 'chantiers':
        page = (
          <ChantiersPage
            {...shared}
            chantiers={chantiers}
            setChantiers={setChantiers}
            clients={clients}
            employes={employes}
            factures={factures}
            setFactures={setFactures}
            devis={devis}
            setDevis={setDevis}
            frais={frais}
            rechargeFactures={rechargeFactures}
            ouvrir={aOuvrir}
          />
        );
        break;
      case 'equipe':
        page = (
          <EquipePage
            {...shared}
            employes={employes}
            setEmployes={setEmployes}
            rechargeEmployes={rechargeEmployes}
            chantiers={chantiers}
            conges={conges}
            setConges={setConges}
            ouvrir={aOuvrir}
            onOuvert={() => setAOuvrir(null)}
            feuilles={feuilles}
          />
        );
        break;
      case 'envoyer':
        page = (
          <EnvoyerEquipe
            {...shared}
            onBack={() => (historique.peutRevenir ? historique.revenir() : allerA('equipe'))}
            employes={employes}
            chantiers={chantiers}
            initial={aOuvrir || {}}
            estMagasin={estMixte ? univers === 'magasin' : soc?.secteur === 'magasin'}
            onEnvoye={() => rechargeChantiers()}
          />
        );
        break;
      case 'formation':
        page = <FormationPage {...shared} employes={employes} setEmployes={setEmployes} />;
        break;
      case 'securite':
        page = <SecuritePage {...shared} />;
        break;
      case 'suggestions':
        page = <SuggestionsPage {...shared} setSoc={setSoc} />;
        break;
      case 'recherche':
        page = (
          <RecherchePage
            {...shared}
            devis={devis}
            factures={factures}
            clients={clients}
            employes={employes}
            chantiers={chantiers}
          />
        );
        break;
      case 'modeles':
        page = <ModelesPage {...shared} catalogue={catalogue} />;
        break;
      case 'courrier':
        page = <CourrierPage {...shared} />;
        break;
      case 'bonsachat':
        page = (
          <BonsAchatPage
            {...shared}
            chantiers={chantiers}
            employes={employes}
            stock={stock}
            ouvrir={aOuvrir}
          />
        );
        break;
      case 'stats':
        page = (
          <StatsPage
            {...shared}
            factures={factures}
            devis={devis}
            ventes={ventes}
            clients={clients}
            frais={frais}
            chantiers={chantiers}
            employes={employes}
          />
        );
        break;
      case 'stock':
        page = (
          <StockPage
            {...shared}
            stock={stock}
            setStock={setStock}
            rechargeStock={rechargeStock}
            chantiers={chantiers}
            rechargeChantiers={rechargeChantiers}
            setFrais={setFrais}
            catalogue={catalogue}
            ventes={ventes}
            setVentes={setVentes}
            clients={clients}
            setClients={setClients}
            initTab="stock"
          />
        );
        break;
      case 'ventes':
        page = (
          <StockPage
            {...shared}
            stock={stock}
            setStock={setStock}
            rechargeStock={rechargeStock}
            chantiers={chantiers}
            rechargeChantiers={rechargeChantiers}
            setFrais={setFrais}
            catalogue={catalogue}
            ventes={ventes}
            setVentes={setVentes}
            clients={clients}
            setClients={setClients}
            initTab="ventes"
          />
        );
        break;
      case 'remises':
        page = (
          <StockPage
            {...shared}
            stock={stock}
            setStock={setStock}
            rechargeStock={rechargeStock}
            chantiers={chantiers}
            rechargeChantiers={rechargeChantiers}
            setFrais={setFrais}
            catalogue={catalogue}
            ventes={ventes}
            setVentes={setVentes}
            clients={clients}
            setClients={setClients}
            initTab="remises"
          />
        );
        break;
      case 'compta':
        page = (
          <ComptaPage
            {...shared}
            setSoc={setSoc}
            factures={factures}
            setFactures={setFactures}
            chantiers={chantiers}
            setChantiers={setChantiers}
            employes={employes}
            conges={conges}
            ventes={ventes}
            stock={stock}
            clients={clients}
            devis={devis}
            commandes={commandes}
            livraisons={livraisons}
            frais={frais}
            setFrais={setFrais}
            ouvrir={aOuvrir}
            attestations={attestations}
            rechargeFactures={rechargeFactures}
            rechargeDevis={rechargeDevis}
            rechargeChantiers={rechargeChantiers}
          />
        );
        break;
      case 'plus':
        page = <PlusPage {...shared} onLock={deconnexion} />;
        break;
      case 'signaux':
        page = (
          <SignauxPage
            {...shared}
            signaux={signaux}
            estMagOuv={estMixte ? univers === 'magasin' : soc?.secteur === 'magasin'}
          />
        );
        break;
      case 'notifs':
        page = (
          <NotificationsPage
            {...shared}
            signaux={session?.employeId != null ? signaux : null}
            devis={devis}
            factures={factures}
            chantiers={chantiers}
            clients={clients}
            conges={conges}
            setConges={setConges}
            employes={employes}
            stock={stock}
            commandes={commandes}
            consultations={consultations.liste}
            onConsultationsVues={consultations.marqueLues}
            attestations={attestations.pieces}
          />
        );
        break;
      case 'reglages':
        page = (
          <ReglagesPage
            {...shared}
            soc={soc}
            setSoc={setSoc}
            employes={employes}
            setEmployes={setEmployes}
            onForceRefresh={forceRefresh}
            vue={vue}
            setVue={setVue}
          />
        );
        break;
      case 'gps':
        page = (
          <GpsPage
            {...shared}
            employes={employes}
            setEmployes={setEmployes}
            chantiers={chantiers}
          />
        );
        break;
      case 'outils':
        page = <OutilsPage {...shared} />;
        break;
      case 'import':
        page = (
          <ImportPage
            {...shared}
            devis={devis}
            setDevis={setDevis}
            factures={factures}
            setFactures={setFactures}
            clients={clients}
            setClients={setClients}
          />
        );
        break;
      case 'archives':
        page = <ArchivesPage {...shared} />;
        break;
      case 'journalco':
        page = <JournalConnexionsPage {...shared} />;
        break;
      case 'inscriptions':
        page = <InscriptionsPage {...shared} />;
        break;
      case 'envois':
        page = <EnvoisPage {...shared} rechargeFactures={rechargeFactures} />;
        break;
      case 'presentation':
        page = <PresentationPage {...shared} />;
        break;
      case 'support':
        page = <SupportPage {...shared} />;
        break;
      case 'ouvrier':
        page = (
          <EspaceOuvrier
            {...shared}
            ouvrir={aOuvrir}
            onOuvert={() => setAOuvrir(null)}
            signaux={signaux}
            employes={employes}
            setEmployes={setEmployes}
            chantiers={chantiers}
            setChantiers={setChantiers}
            conges={conges}
            setConges={setConges}
            rdv={rdv}
            stock={stock}
            setStock={setStock}
            rechargeStock={rechargeStock}
            rechargeChantiers={rechargeChantiers}
            feuilles={feuilles}
            setFeuilles={setFeuilles}
          />
        );
        break;
      case 'depenses':
        page = (
          <DepensesPage
            {...shared}
            ouvrir={aOuvrir}
            chantiers={chantiers}
            setChantiers={setChantiers}
            frais={frais}
            setFrais={setFrais}
            setSoc={setSoc}
          />
        );
        break;
      case 'commandes':
        page = (
          <CommandesPage
            {...shared}
            commandes={commandes}
            setCommandes={setCommandes}
            clients={clients}
            stock={stock}
            livraisons={livraisons}
            setLivraisons={setLivraisons}
            ouvrir={aOuvrir}
          />
        );
        break;
      case 'livraisons':
        page = (
          <LivraisonsPage
            {...shared}
            livraisons={livraisons}
            setLivraisons={setLivraisons}
            clients={clients}
            factures={factures}
            facturesActives={facturesActives}
            rechargeFactures={rechargeFactures}
            stock={stock}
            rechargeStock={rechargeStock}
          />
        );
        break;
      case 'rdv':
        page = (
          <RendezVousPage
            {...shared}
            rdv={rdv}
            setRdv={setRdv}
            clients={clients}
            chantiers={chantiers}
            employes={employes}
          />
        );
        break;
      case 'planning':
        page = (
          <PlanningPage
            {...shared}
            chantiers={chantiers}
            setChantiers={setChantiers}
            employes={employes}
            conges={conges}
          />
        );
        break;
      case 'partage':
        page = <PartagePage {...shared} />;
        break;
      case 'decharge':
        page = <DechargePage {...shared} clients={clients} employes={employes} />;
        break;
      case 'soumissions':
        page = (
          <SoumissionsPage
            {...shared}
            devis={devis}
            setDevis={setDevis}
            catalogue={catalogue}
            setCatalogue={setCatalogue}
            clients={clients}
          />
        );
        break;
      case 'abonnement':
        page = (
          <AbonnementPage {...shared} onModule={surModule} aConfirmer={souscriptionAConfirmer} />
        );
        break;
      case 'clients':
        page = (
          <ClientsPage
            {...shared}
            clients={clients}
            setClients={setClients}
            devis={devis}
            factures={factures}
            chantiers={chantiers}
            catalogue={catalogue}
            stock={stock}
            ouvrir={aOuvrir}
          />
        );
        break;
      case 'ouverture':
        page = (
          <ClientsPage
            {...shared}
            startOuv
            clients={clients}
            setClients={setClients}
            devis={devis}
            factures={factures}
            chantiers={chantiers}
            catalogue={catalogue}
            stock={stock}
          />
        );
        break;
      case 'articles':
        page = (estMixte ? univers === 'magasin' : soc.secteur === 'magasin') ? (
          <StockPage
            {...shared}
            stock={stock}
            setStock={setStock}
            rechargeStock={rechargeStock}
            chantiers={chantiers}
            rechargeChantiers={rechargeChantiers}
            setFrais={setFrais}
            catalogue={catalogue}
            ventes={ventes}
            setVentes={setVentes}
            clients={clients}
            setClients={setClients}
            initTab="stock"
            initAdd={true}
          />
        ) : (
          <ArticlesBatimentPage {...shared} catalogue={catalogue} setCatalogue={setCatalogue} />
        );
        break;
      case 'aide':
        page = <AidePage {...shared} />;
        break;
      default:
        page = (
          <Shell
            active={nav}
            onNav={allerA}
            soc={soc}
            estMixte={estMixte}
            univers={univers}
            setUnivers={estOuvrier ? undefined : changerUnivers}
            pageTitle={titre}
          >
            <EcranAVenir route={nav} />
          </Shell>
        );
    }
    content = (
      <HistoriqueNavigation.Provider
        value={{ peutRevenir: historique.peutRevenir, revenir: historique.revenir }}
      >
        <Fragment key={route + ':' + passage}>{page}</Fragment>
      </HistoriqueNavigation.Provider>
    );
  }

  return (
    <ReglagesProvider soc={soc} setSoc={setSoc}>
      {/*
        La boite de saisie remplace `window.prompt`, que Chrome bloque dans un
        cadre et qu'une application installee sur l'ecran d'accueil d'un iPhone
        n'affiche pas du tout.
      */}
      <DialogueProvider>
        <div
          className="st-outer"
          style={{
            width: '100%',
            minHeight: '100svh',
            background: '#0f1626',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'stretch',
          }}
        >
          <style>
            {
              '@keyframes stspin{to{transform:rotate(360deg)}} *{box-sizing:border-box} button,input,textarea{font-family:inherit} ::-webkit-scrollbar{width:0;height:0} html,body{overflow-x:hidden;overscroll-behavior:none} .st-outer{overflow-x:hidden} .st-frame{width:100%;height:100vh;height:100svh;overscroll-behavior:contain} @media print{.no-print{display:none!important}.doc-root{height:auto!important;overflow:visible!important;background:#fff!important} html,body,.st-outer,.st-frame,.st-contenu{height:auto!important;overflow:visible!important;background:#fff!important;display:block!important}.st-frame{position:static!important}}'
            }
          </style>
          <div
            className="st-frame"
            style={{
              // Fixé aux bords de l'écran : quelle que soit la hauteur que
              // l'iPhone donne à la page (barre de Safari repliée, retour de
              // WhatsApp), le cadre en couvre exactement la partie visible.
              position: 'fixed',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              height: 'auto',
              background: C.bg,
              overflow: 'hidden',
              fontFamily: 'system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
              // L'application occupe tout l'écran et s'y adapte (lib/ecran.js).
              // Seul le format « Téléphone » choisi sur un grand écran garde
              // la fenêtre étroite, centrée.
              ...(vue === 'telephone' && winW >= 760
                ? {
                    position: 'relative',
                    maxWidth: 480,
                    height: '94svh',
                    alignSelf: 'center',
                    borderRadius: 22,
                    boxShadow: '0 18px 60px rgba(0,0,0,.45)',
                  }
                : {}),
            }}
          >
            {/* L'heure et la batterie de l'iPhone se posent au-dessus de
                l'application installée : une bande à la couleur de l'en-tête
                leur fait place, sur tous les écrans (pages et documents). */}
            <div
              aria-hidden="true"
              className="no-print"
              style={{ height: 'var(--st-haut)', background: C.navy }}
            />
            {/* Sous Safari d'iPhone, une bande fixe à la couleur de l'en-tête
                couvre le haut : Safari en reprend la teinte au lieu de
                flouter l'en-tête (lib/bord-haut.js). */}
            {IOS_NAVIGATEUR && (
              <div
                aria-hidden="true"
                className="no-print"
                style={{
                  position: 'fixed',
                  top: 0,
                  left: 0,
                  right: 0,
                  height: 'var(--st-haut)',
                  background: C.navy,
                  zIndex: 2,
                  pointerEvents: 'none',
                }}
              />
            )}
            <div className="st-contenu" style={{ height: 'calc(100% - var(--st-haut))' }}>
              {content}
            </div>
            {sessionOuverte && (
              <SignalConsultation
                consultation={consultations.nouvelle}
                onFerme={consultations.oublieNouvelle}
                onOuvre={() => allerA('notifs')}
                motOffre={motOffre(soc).toLowerCase()}
              />
            )}
            <BandeauxPwa />
            {(enregistrement || (erreurReseau && erreurReseau !== erreurFermee)) && (
              <div
                className="no-print"
                role="status"
                style={{
                  position: 'absolute',
                  left: 0,
                  right: 0,
                  top: 0,
                  zIndex: 60,
                  background: erreurReseau ? C.red : C.navy,
                  color: '#fff',
                  fontSize: 10.5,
                  fontWeight: 700,
                  textAlign: 'center',
                  padding: '5px 10px',
                  letterSpacing: 0.2,
                }}
              >
                {erreurReseau
                  ? '\u26a0 ' + (erreurReseau.message || "L'enregistrement a \u00e9chou\u00e9.")
                  : '\u2601 Enregistrement\u2026'}
                {/*
                  Un employe refuse parce que la formule est pleine : le
                  message nomme la formule superieure, le lien y mene.
                */}
                <LienFormules erreur={erreurReseau} onNav={allerA} clair />
                {erreurReseau && (
                  <button
                    aria-label="Fermer"
                    onClick={() => setErreurFermee(erreurReseau)}
                    style={{
                      marginLeft: 10,
                      background: 'transparent',
                      border: '1px solid rgba(255,255,255,.6)',
                      color: '#fff',
                      borderRadius: 6,
                      padding: '1px 7px',
                      cursor: 'pointer',
                      fontSize: 10,
                    }}
                  >
                    ✕
                  </button>
                )}
              </div>
            )}
            {/*
              La pastille flottait au bas de tous les ecrans, sur le bouton
              principal de la page en vue telephone — « Convertir en facture »,
              « Encaisser ». Tant que l'essai court, elle ne parait qu'a
              l'accueil ; l'essai termine, elle reste partout : il faut agir.
              Comme dans la maquette, elle attend la fin de la configuration de
              depart : sur l'assistant, elle masquait « Lancer SwissTech ».
            */}
            {soc &&
              soc.secteur &&
              auth &&
              !abonne &&
              !estOuvrier &&
              !trialHide &&
              // Pendant l'essai, l'accueil la montre dans sa page : flottante,
              // elle cachait le bénéfice net sur l'iPhone.
              trialLeft <= 0 && (
                <div
                  className="no-print"
                  style={{
                    position: 'absolute',
                    left: 0,
                    right: 0,
                    bottom: 78,
                    display: 'flex',
                    justifyContent: 'center',
                    pointerEvents: 'none',
                    zIndex: 40,
                  }}
                >
                  <div
                    style={{
                      pointerEvents: 'auto',
                      display: 'flex',
                      alignItems: 'center',
                      gap: 9,
                      background: C.navy,
                      color: '#fff',
                      borderRadius: 99,
                      padding: '7px 8px 7px 14px',
                      boxShadow: '0 6px 18px rgba(0,0,0,.32)',
                      fontSize: 10.5,
                      fontWeight: 700,
                    }}
                  >
                    <span onClick={() => setNav('abonnement')} style={{ cursor: 'pointer' }}>
                      {trialLeft > 0
                        ? '🎁 Essai gratuit · ' +
                          trialLeft +
                          ' jour' +
                          (trialLeft > 1 ? 's' : '') +
                          ' restant' +
                          (trialLeft > 1 ? 's' : '')
                        : '⏳ Essai terminé · choisissez une formule'}
                    </span>
                    <button
                      type="button"
                      aria-label="Masquer"
                      onClick={() => setTrialHide(true)}
                      style={{
                        background: 'rgba(255,255,255,.18)',
                        border: 'none',
                        color: '#fff',
                        borderRadius: 99,
                        width: 20,
                        height: 20,
                        fontSize: 11,
                        cursor: 'pointer',
                        lineHeight: 1,
                      }}
                    >
                      ✕
                    </button>
                  </div>
                </div>
              )}
            {/*
              Essai termine sans formule souscrite : le bureau se ferme, sauf la
              page Abonnement, par laquelle on en sort. L'etat est celui que le
              serveur a calcule ; les ouvriers ne sont jamais arretes.
            */}
            {voileFinEssaiVisible({ soc, role: auth, nav }) && (
              <VoileFinEssai
                patron={auth === 'patron'}
                onFormules={() => allerA('abonnement')}
                onConfirmer={() => {
                  setSouscriptionAConfirmer(true);
                  allerA('abonnement');
                }}
                onDeconnexion={deconnexion}
              />
            )}
          </div>
        </div>
      </DialogueProvider>
    </ReglagesProvider>
  );
}

export default App;
